import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

const TooltipBday = () => {
  const { t } = useTranslation();

  return (
    <div className="info-tooltip" data-bem="TooltipBday">
      <i>{t('clientConnect.tooltipGuide')}</i>
      <div className="client-info-icon">
        <span className="tooltip">
          <div className="tooltip-centered">{t('clientConnect.bdayTooltipText')}</div>
        </span>
      </div>
    </div>
  );
};

export default TooltipBday;
